import { React, useState, useEffect } from "react";
import "./PositionsAndMemberships.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import point from "../../assets/bulletpoint.svg";
import ark from "../../assets/icons/arkColoredIcon.svg";
import edamaColored from "../../assets/icons/edamaColored.svg";
import taya from "../../assets/icons/tayaIcon.svg";
import wijhatech from "../../assets/icons/DITcompanies.svg";
// import wijhamakan from "../../assets/icons/wijhamakan.svg"
import waja from "../../assets/icons/wajarealestate.svg";
import jasara from "../../assets/icons/jasara logo1.png";
import twaiq from "../../assets/icons/twaiq.webp";
import qima from "../../assets/icons/qima.webp";
import waheedback from "../../assets/icons/bg.svg";
import leftblue from "../../assets/leftblue.svg";
import nama from "../../assets/icons/nama.png";
import { useTranslation } from "react-i18next";

export default function Positions() {
  const { t, i18n } = useTranslation();

  const [activeIndex, setActiveIndex] = useState(1);

  // state to manage the slides per view based on the screen size
  const [slidesPerView, setSlidesPerView] = useState(calculateSlidesPerView());

  // Function to determine slidesPerView based on screen width
  function calculateSlidesPerView() {
    if (typeof window !== "undefined") {
      // Check if running in browser (client-side)
      if (window.innerWidth < 768) {
        // Small screens (adjust breakpoint as needed)
        return 1;
      } else {
        return 3; // Default for larger screens (adjust as needed)
      }
    }
    return 3; // Default value if window is not defined (server-side rendering)
  }

  // Update slidesPerView on window resize
  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setSlidesPerView(calculateSlidesPerView());
      };

      window.addEventListener("resize", handleResize);

      // Clean up event listener on unmount
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const positions = t("positions", { returnObjects: true }).map((pos) => ({
    ...pos,
    logo: {
      taya,
      ark,
      edamaColored,
      waja,
      jasara,
      wijhatech,
      nama,
      twaiq,
      qima,
    }[pos.logo],
  }));
  return (
    <section id="positions_and_memberships">
      <div className="positions-container">
        <h2 className="section-title">
          <img src={leftblue} className="left-blue" />
          <img src={point} className="point" />
          {t("positions_and_memberships")}
          <img src={point} className="point" />
        </h2>
        <img src={waheedback} className="waheedback" />
        <Swiper
          navigation={true}
          modules={[Navigation, Autoplay]}
          spaceBetween={35}
          slidesPerView={slidesPerView}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          speed={1000}
          loopedSlides={positions.length}
          onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          className="positions-slider"
        >
          {positions.map((pos, index) => (
            <SwiperSlide
              key={index}
              className={`position-card ${
                index === activeIndex ? "hover" : ""
              }`}
            >
              <div className="position-logo">
              <img src={pos.logo} alt={pos.title}  />   </div>
              <h3>{pos.title}</h3>
              {/* <p style={{ margin: "25px", color: "black" }}>
                {pos.description}
              </p> */}
              <hr className="hr" />
              <strong> {pos.role} </strong>
           
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
